import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Question } from '_models/question';

@Injectable()
export class QuestionControlService {

  toFormGroup(questions: Question[]) {
    const group: any = {};

    questions.forEach(question => {
      // New release of Angular allows for updateOn: 'submit"  https://github.com/angular/angular/pull/18514
      group[question.id] = new UntypedFormControl(question.value ?? '');
    });
    return new UntypedFormGroup(group);
  }
}

